import React, { useState } from 'react'

const initialState = { isUSRegion: false, setActiveUSRegion: () => {} }

export const RegionContext = React.createContext(initialState)

export function RegionProvider({ children }) {
  const [isUSRegion, setIsUSRegion] = useState(false)

  const setActiveUSRegion = region => {
    setIsUSRegion(region)
  }

  const contextValue = React.useMemo(
    () => ({
      isUSRegion,
      setActiveUSRegion,
    }),
    [isUSRegion]
  )

  return (
    <RegionContext.Provider value={contextValue}>
      {children}
    </RegionContext.Provider>
  )
}
